// extracted by mini-css-extract-plugin
export default {"main":"App_main__Ouif1","section":"App_section__URF-j","article":"App_article__4-4al"};